module.exports = "/images/changeDelivery.gif";